import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Menu from "./Menu/Menu.js";

export default function Header() {
  const [click, setClick] = useState(false);
  const [blindMode, setBlindMode] = useState(false);

  function handleClick() {
    setClick(!click);
  }

  function handleIncrease() {
    setBlindMode(!blindMode);
  }

  // При включении версии для слабовидящих вешаем класс на body
  useEffect(() => {
    if (blindMode) {
      document.body.classList.add("blind-mode");
    } else {
      document.body.classList.remove("blind-mode");
    }
  }, [blindMode]);

  return (
    <section className="header">
      <div className="header__up">
        <Link className="header__link" to="/">
          <div className="header__logo"></div>
          <div className="header__block-name">
            <p className="header__name">
              Государственное бюджетное учреждение Свердловской области
            </p>
            <p className="header__name">
              «Уральский научно-исследовательский институт дерматовенерологии и
              иммунопатологии»
            </p>
          </div>
        </Link>
        <a href="tel:+73432189586" className="header__tel">
          +7 (343) 218-95-86
        </a>
        <button
          type="button"
          className="header__blind"
          onClick={handleIncrease}
        >
          {blindMode ? "Обычная версия" : "Версия для слабовидящих"}
        </button>
      </div>

      <Menu isOpen={click} onClose={handleClick} />

      <button
        type="button"
        className="header__burger"
        onClick={handleClick}
      ></button>
    </section>
  );
}
